(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kana-ai"] && !Shopify.designMode) return;
  try {
    

(() => {
  const setup = root => {
    if(root.dataset.kaiReady) return;
    root.dataset.kaiReady = 'true';
    const copy = JSON.parse(root.querySelector('[data-kai-copy]').textContent);
    const dialog = root.querySelector('dialog');
    let step = 1, selected = null, opener;
    const show = () => {
      root.querySelectorAll('[data-kai-step]').forEach(el => el.hidden = Number(el.dataset.kaiStep) !== step);
      root.querySelector('[data-kai-progress]').textContent = copy.steps[step - 1];
      const title = root.querySelector('[data-kai-title]');
      title.textContent = copy.titles[step - 1];
      root.querySelector('[data-kai-back]').hidden = step === 1;
      root.querySelector('[data-kai-next]').hidden = step === 3;
      root.querySelector('[data-kai-next]').disabled = !selected;
      if (selected) {
        root.querySelector('[data-kai-selection]').textContent = copy.journals[selected].name;
        root.querySelector('[data-kai-final]').textContent = copy.journals[selected].name;
        root.querySelector('[data-kai-description]').textContent = copy.journals[selected].description;
      }
      dialog.scrollTop = 0;
      if(dialog.open) title.focus();
    };
    root.querySelectorAll('[data-kai-open]').forEach(button => button.addEventListener('click', () => {
      opener = button;
      const bundle = button.dataset.kaiOpen === 'complete';
      root.querySelector('[data-kai-start]').hidden = bundle;
      root.querySelector('[data-kai-bundle]').hidden = !bundle;
      step = 1; show();
      const title = root.querySelector(bundle ? '[data-kai-bundle-title]' : '[data-kai-title]');
      if(bundle) { title.id = 'kai-bundle-' + root.closest('[id]').id; }
      dialog.setAttribute('aria-labelledby',title.id);
      dialog.showModal(); title.focus();
    }));
    root.querySelectorAll('[data-kai-choice]').forEach(button => button.addEventListener('click', () => {
      selected = button.dataset.kaiChoice;
      root.querySelectorAll('[data-kai-choice]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
      root.querySelector('[data-kai-next]').disabled = false;
    }));
    root.querySelector('[data-kai-next]').addEventListener('click', () => { if(selected && step < 3){step++; show();} });
    root.querySelector('[data-kai-back]').addEventListener('click', () => { if(step > 1){step--; show();} });
    root.querySelector('[data-kai-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => opener?.focus());
  };
  document.querySelectorAll('[data-kana-ai]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-kana-ai]').forEach(setup));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kana-course-entry"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const ui = JSON.parse(root.querySelector('[data-entry-ui]').textContent);
  const status = root.querySelector('[data-entry-status]'), retry = root.querySelector('[data-entry-retry]'), login = root.querySelector('[data-entry-login]');
  const open = async () => {
   status.hidden = false; status.textContent = ui.loading; retry.hidden = false; retry.disabled = true; login.hidden = true;
   const abort = new AbortController(), timer = setTimeout(() => abort.abort(), 20000);
   try {
    const response = await fetch(root.dataset.proxy + '/api/bootstrap', {credentials:'same-origin',cache:'no-store',signal:abort.signal,headers:{Accept:'application/json'}});
    const data = JSON.parse(await response.text());
    if (response.status === 401 && data.error === 'LOGIN_REQUIRED') { status.textContent = ui.login; login.hidden = false; retry.hidden = true; return; }
    if (!response.ok) throw new Error('unavailable');
    if (!Array.isArray(data.courses)) throw new Error('unavailable');
    if (data.courses.length === 0) {status.textContent = ui.empty; return;}
    location.assign(root.dataset.proxy);
   } catch {status.textContent = ui.error;}
   finally {clearTimeout(timer); retry.disabled = false;}
  };
  retry.addEventListener('click',open);
  if (root.dataset.customer === 'yes') open();
 };
 document.querySelectorAll('[data-kana-course-entry]').forEach(init);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-kana-course-entry]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kana-course-offer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.ready) return;
    const data = JSON.parse(root.querySelector('[data-kana-course-data]').textContent);
    const ui = JSON.parse(root.querySelector('[data-kana-course-ui]').textContent);
    const variantIds = {journal: '58747787706742', habit: '58747787739510', fitness: '58747787772278', budget: '58747787805046', business: '58747787837814', travel: '58747787870582', books: '58814477140342'};
    const getVariant = id => {
      const fallback = {id: variantIds[id], price: root.dataset.singlePrice+' €', available: true};
      try {
        const source = root.querySelector('[data-kana-checkout-variants]');
        const variant = source ? JSON.parse(source.textContent)[id] : null;
        return variant && /^\d+$/.test(String(variant.id)) ? variant : fallback;
      } catch (error) { return fallback; }
    };
    const el = (tag, text, cls) => { const n = document.createElement(tag); if(text) n.textContent=text; if(cls) n.className=cls; return n; };
    const cover=(c,cls)=> { const n=el('img',null,cls); const u=new URL(c.image,location.href);u.searchParams.set('width','640');n.src=u.href;n.srcset=[240,480,640].map(w=>{const v=new URL(u);v.searchParams.set('width',String(w));return v.href+' '+w+'w';}).join(', ');n.sizes=cls==='kc-topic-cover'?'(max-width:650px) 42vw, 220px':'(max-width:650px) 85vw, 440px';n.decoding='async';n.alt=c.name; n.width=440;n.height=550;n.loading='lazy';return n; };
    const picker=root.querySelector('.kc-picker'), topics=root.querySelector('[data-picker-topics]'), detail=root.querySelector('[data-picker-detail]'), summary=root.querySelector('[data-picker-summary]'), step=root.querySelector('[data-picker-step]'), heading=root.querySelector('#kc-picker-heading');
    let pack='single', chosen=data[0];
    const button=(text,action,cls='kc-button')=>{const b=el('button',text,cls);b.type='button';b.addEventListener('click',action);return b;};
    const focus=()=>{heading.focus({preventScroll:true});picker.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});};
    const show=(state)=>{topics.hidden=state!==1;detail.hidden=state!==2;summary.hidden=state!==3;step.textContent=ui['step_'+state];heading.textContent=ui['picker_heading_'+state];root.querySelector('[data-picker-intro]').hidden=state!==1;root.querySelector('[data-picker-status]').textContent=step.textContent;};
    const details=c=>{chosen=c;detail.replaceChildren();const box=el('div',null,'kc-selection');box.append(cover(c,'kc-selected-cover'));const copy=el('div');copy.append(el('p',c.label,'kc-eyebrow'),el('h3',c.name),el('p',c.description));const list=el('ol',null,'kc-curriculum-list');(pack==='bundle'?[...c.weeks,...c.bundle_extension]:c.weeks).forEach((w,i)=>list.append(el('li',`${ui.week} ${i+1}: ${w.title}`)));copy.append(list,button(ui.continue,()=>{summarize();show(3);focus();}),button(ui.back_topics,()=>{show(1);focus();},'kc-quiet'));box.append(copy);detail.append(box);show(2);focus();};
    const summarize=()=>{
      summary.replaceChildren();
      const box=el('div',null,'kc-summary');
      const variant=getVariant(chosen.id);
      box.append(el('p',ui.single_title,'kc-eyebrow'),el('h3',chosen.name),el('p',ui.summary_single));
      box.append(el('p',variant ? variant.price : root.dataset.singlePrice+' €','kc-price'),el('p',root.dataset.checkoutPriceNote,'kc-small'));
      if (variant && variant.available && /^\d+$/.test(String(variant.id))) {
        const checkout=el('a',root.dataset.checkoutLabel,'kc-button');
        checkout.href=(root.dataset.cartUrl || ui.root+'cart')+'/'+variant.id+':1';
        box.append(checkout);
      } else {
        box.append(el('p',root.dataset.unavailable,'kc-callout'));
      }
      box.append(button(ui.back_detail,()=>{show(2);focus();},'kc-quiet'));
      summary.append(box);
    };
    data.forEach(c=>{const b=button('',()=>details(c),'kc-topic');b.append(cover(c,'kc-topic-cover'),el('span',c.label,'kc-topic-title'),el('span',c.name,'kc-small'),el('span',c.description,'kc-topic-description'));topics.append(b);});
    root.querySelectorAll('[data-package]').forEach(b=>b.addEventListener('click',()=>{pack=b.dataset.package;picker.hidden=false;show(1);focus();}));
    root.dataset.ready = 'true';
  };
  const initializeOffers = () => document.querySelectorAll('[data-kana-offer]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeOffers, {once: true});
  else initializeOffers();
  document.addEventListener('shopify:section:load',e=>{e.target.querySelectorAll('[data-kana-offer]').forEach(init);});
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kana-course-room"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init=root=>{
  if(!root||root.dataset.ready)return;root.dataset.ready='true';
  const courses=JSON.parse(root.querySelector('[data-kana-course-data]').textContent),ui=JSON.parse(root.querySelector('[data-kana-course-ui]').textContent);
  const q=s=>root.querySelector(s),all=s=>root.querySelectorAll(s),el=(tag,text,cls)=>{const n=document.createElement(tag);if(text!==undefined)n.textContent=text;if(cls)n.className=cls;return n;};
  const KEY='kana-course-notebook-v2',LEGACY='kana-course-notebook-v1',MAX=12000;
  const weeksFor=(c,pack)=>{if(pack!=='bundle')return c.weeks;const weeks=[...c.weeks,...c.bundle_extension];weeks[5]=structuredClone(weeks[5]);weeks[5].days[5].title=ui.interim_plan;weeks[5].days[6]={title:ui.interim_title,instruction:ui.interim_copy,questions:[ui.interim_question_1,ui.interim_question_2,ui.interim_question_3]};return weeks;};
  const fresh=()=>({version:2,pack:'single',selected:'journal',position:{},entries:{},completed:{}});
  let state=fresh(),persist=false,storageError=false,dirty=false,week=0,day=0;
  const validId=id=>courses.some(c=>c.id===id);
  const validKey=key=>{const bits=key.split(':');return bits.length===4&&['single','bundle'].includes(bits[0])&&validId(bits[1])&&/^\d$/.test(bits[2])&&Number(bits[2])<(bits[0]==='bundle'?8:6)&&/^[0-6]$/.test(bits[3]);};
  const clean=input=>{
   if(input?.version===1){input={...input,version:2,pack:'single',position:Object.fromEntries(Object.entries(input.position||{}).map(([k,v])=>['single:'+k,v])),entries:Object.fromEntries(Object.entries(input.entries||{}).map(([k,v])=>['single:'+k,v])),completed:Object.fromEntries(Object.entries(input.completed||{}).map(([k,v])=>['single:'+k,v]))};}
   if(!input||input.version!==2||!input.entries||typeof input.entries!=='object'||Array.isArray(input.entries)||!input.completed||typeof input.completed!=='object')throw Error('invalid');
   const out=fresh();if(['single','bundle'].includes(input.pack))out.pack=input.pack;if(validId(input.selected))out.selected=input.selected;
   for(const [key,values] of Object.entries(input.entries)){if(!validKey(key)||!Array.isArray(values)||values.length>6||values.some(v=>typeof v!=='string'||v.length>MAX))throw Error('invalid');out.entries[key]=values.slice();}
   for(const [key,value] of Object.entries(input.completed)){if(!validKey(key)||typeof value!=='boolean')throw Error('invalid');if(value)out.completed[key]=true;}
   for(const pack of ['single','bundle'])for(const c of courses){const pk=pack+':'+c.id,p=input.position?.[pk];if(Array.isArray(p)&&p.length===2&&Number.isInteger(p[0])&&p[0]>=0&&p[0]<(pack==='bundle'?8:6)&&Number.isInteger(p[1])&&p[1]>=0&&p[1]<7)out.position[pk]=p;}
   return out;
  };
  try{const stored=localStorage.getItem(KEY)||localStorage.getItem(LEGACY);if(stored){state=clean(JSON.parse(stored));persist=true;}}catch(e){storageError=true;}
  const params=new URLSearchParams(location.search);if(['single','bundle'].includes(params.get('paket')))state.pack=params.get('paket');if(validId(params.get('journal')))state.selected=params.get('journal');
  [week,day]=state.position[state.pack+':'+state.selected]||[0,0];
  const current=()=>courses.find(c=>c.id===state.selected),weeks=()=>weeksFor(current(),state.pack),total=()=>weeks().length*7,prefix=()=>state.pack+':'+state.selected,key=()=>`${prefix()}:${week}:${day}`;
  const storageText=()=>{q('[data-storage-status]').textContent=storageError?ui.storage_error:persist?ui.storage_on:ui.storage_off;q('[data-persist]').checked=persist;};
  const save=(changed=false)=>{if(changed)dirty=true;state.position[state.pack+':'+state.selected]=[week,day];if(persist){try{localStorage.setItem(KEY,JSON.stringify(state));localStorage.removeItem(LEGACY);storageError=false;q('[data-save-status]').textContent=ui.saved_device;}catch(e){storageError=true;q('[data-save-status]').textContent=ui.storage_error;}}else q('[data-save-status]').textContent=ui.saved_session;storageText();};
  const progress=()=>{const count=Object.keys(state.completed).filter(k=>k.startsWith(prefix()+':')&&state.completed[k]).length;q('[data-progress]').max=total();q('[data-progress]').value=count;q('[data-progress]').textContent=`${count} / ${total()}`;q('[data-progress-text]').textContent=`${count} / ${total()} ${ui.completed_units}`;q('[data-complete]').textContent=state.completed[key()]?ui.undo_complete:ui.complete;q('[data-finish]').hidden=count<total();all('[data-week-index]').forEach(b=>{const i=Number(b.dataset.weekIndex),done=Array.from({length:7},(_,d)=>state.completed[`${prefix()}:${i}:${d}`]).filter(Boolean).length;b.querySelector('small').textContent=`${done} / 7`;});all('[data-day-index]').forEach(b=>{const d=Number(b.dataset.dayIndex);b.classList.toggle('is-done',!!state.completed[`${prefix()}:${week}:${d}`]);b.setAttribute('aria-label',`${ui.day} ${d+1}${state.completed[`${prefix()}:${week}:${d}`]?', '+ui.done:''}`);});};
  const choose=(w,d,focus=true)=>{week=w;day=d;state.position[state.pack+':'+state.selected]=[w,d];render();save();if(focus==='entry'){requestAnimationFrame(()=>{const field=q('.kc-field');field?.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});q('.kc-field textarea')?.focus({preventScroll:true});});}else if(focus)q('[data-lesson-title]').focus({preventScroll:true});};
  const render=()=>{
   const c=current(),w=weeks()[week],task=w.days[day];q('[data-course-select]').value=c.id;q('[data-package-select]').value=state.pack;const img=q('[data-room-cover]');img.src=c.image;img.alt=c.name;
   q('[data-week-label]').textContent=`${ui.week} ${week+1} / ${weeks().length} · ${c.name}`;q('[data-lesson-title]').textContent=w.title;q('[data-lesson-copy]').textContent=w.lesson;q('[data-page-name]').textContent=w.page;
   const weeksNav=q('[data-weeks]');weeksNav.replaceChildren();weeks().forEach((item,i)=>{const b=el('button',undefined,'kc-week-button');b.type='button';b.dataset.weekIndex=i;b.setAttribute('aria-current',i===week?'step':'false');b.append(el('span',`${String(i+1).padStart(2,'0')}  ${item.title}`),el('small'));b.addEventListener('click',()=>choose(i,0));weeksNav.append(b);});
   const days=q('[data-days]');days.replaceChildren();w.days.forEach((_,i)=>{const b=el('button',String(i+1));b.type='button';b.dataset.dayIndex=i;b.setAttribute('aria-pressed',String(i===day));b.addEventListener('click',()=>choose(week,i));days.append(b);});
   q('[data-day-label]').textContent=`${ui.unit} ${week*7+day+1} / ${total()}`;q('[data-task-title]').textContent=task.title;q('[data-task-instruction]').textContent=task.instruction;
   const form=q('[data-entry-form]');form.replaceChildren();const values=state.entries[key()]||[];task.questions.forEach((question,i)=>{const wrap=el('div',undefined,'kc-field'),label=el('label',question),input=el('textarea');input.id='kc-entry-'+i;input.name='entry-'+i;input.rows=3;input.maxLength=MAX;input.value=values[i]||'';input.placeholder=ui.entry_placeholder;label.htmlFor=input.id;input.addEventListener('input',()=>{const k=key();if(!state.entries[k])state.entries[k]=Array(task.questions.length).fill('');state.entries[k][i]=input.value;save(true);});wrap.append(label,input);form.append(wrap);});
   q('[data-next]').disabled=week===weeks().length-1&&day===6;q('[data-save-status]').textContent=persist?ui.saved_device:ui.saved_session;progress();
  };
  courses.forEach(c=>{const option=el('option',c.name);option.value=c.id;q('[data-course-select]').append(option);});
  q('[data-course-select]').addEventListener('change',e=>{state.selected=e.target.value;[week,day]=state.position[state.pack+':'+state.selected]||[0,0];render();save();});
  q('[data-package-select]').addEventListener('change',e=>{state.pack=e.target.value;[week,day]=state.position[state.pack+':'+state.selected]||[0,0];render();save();});
  q('[data-entry-form]').addEventListener('submit',e=>e.preventDefault());
  q('[data-complete]').addEventListener('click',()=>{const k=key();if(state.completed[k])delete state.completed[k];else state.completed[k]=true;save(true);progress();q('[data-save-status]').textContent=state.completed[k]?ui.marked_complete:ui.marked_open;});
  q('[data-next]').addEventListener('click',()=>{if(day<6)choose(week,day+1,'entry');else if(week<weeks().length-1)choose(week+1,0,'entry');});
  const confirmAction=(title,copy,fn)=>{const dialog=q('[data-confirm]');q('[data-confirm-title]').textContent=title;q('[data-confirm-copy]').textContent=copy;const yes=q('[data-confirm-yes]');yes.onclick=()=>{dialog.close();fn();};q('[data-confirm-no]').onclick=()=>dialog.close();dialog.showModal();};
  q('[data-persist]').addEventListener('change',e=>{persist=e.target.checked;if(persist)save();else{dirty=Object.keys(state.entries).length>0||Object.keys(state.completed).length>0;try{localStorage.removeItem(KEY);localStorage.removeItem(LEGACY);storageError=false;}catch(err){storageError=true;}storageText();q('[data-save-status]').textContent=ui.saved_session;}});
  const download=(text,name,type)=>{const url=URL.createObjectURL(new Blob([text],{type}));const a=el('a');a.href=url;a.download=name;root.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);q('[data-tools-status]').textContent=ui.exported;if(type==='application/json')dirty=false;};
  q('[data-export-json]').addEventListener('click',()=>download(JSON.stringify(state,null,2),'kana-kurs-sicherung.json','application/json'));
  const notes=()=>{const lines=[ui.export_title,'',new Date().toLocaleDateString('de-DE'),''];for(const pack of ['single','bundle'])for(const c of courses){const pre=pack+':'+c.id;const used=Object.keys(state.entries).some(k=>k.startsWith(pre+':'));if(!used)continue;lines.push(pack==='bundle'?ui.package_bundle:ui.package_single,c.name,'='.repeat(c.name.length),'');weeksFor(c,pack).forEach((w,wi)=>{w.days.forEach((task,di)=>{const k=`${pre}:${wi}:${di}`,values=state.entries[k];if(!values)return;lines.push(`${ui.week} ${wi+1} · ${ui.day} ${di+1}: ${task.title}`,`${ui.journal_page} ${w.page}`,'');task.questions.forEach((question,i)=>{lines.push(question,values[i]||'—','');});});});}return lines.join('\n');};
  all('[data-export-text]').forEach(b=>b.addEventListener('click',()=>download(notes(),'kana-kurs-meine-notizen.txt','text/plain;charset=utf-8')));
  q('[data-import]').addEventListener('change',async e=>{const input=e.target,file=input.files[0];if(!file)return;try{if(file.size>50000000)throw Error('size');const next=clean(JSON.parse(await file.text()));confirmAction(ui.import_title,ui.import_copy,()=>{state=next;[week,day]=state.position[state.pack+':'+state.selected]||[0,0];render();save(true);q('[data-tools-status]').textContent=ui.imported;});}catch(err){q('[data-tools-status]').textContent=ui.import_error;}input.value='';});
  q('[data-delete]').addEventListener('click',()=>confirmAction(ui.delete_title,ui.delete_copy,()=>{try{localStorage.removeItem(KEY);localStorage.removeItem(LEGACY);storageError=false;}catch(e){storageError=true;}state=fresh();persist=false;dirty=false;week=0;day=0;render();storageText();q('[data-tools-status]').textContent=storageError?ui.storage_error:ui.deleted;}));
  window.addEventListener('beforeunload',e=>{if(dirty&&(!persist||storageError)){e.preventDefault();e.returnValue='';}});
  render();storageText();
 };
 document.querySelectorAll('[data-kana-room]').forEach(init);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-kana-room]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kana-free-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const courses = JSON.parse(root.querySelector('[data-demo-data]').textContent);
    const ui = JSON.parse(root.querySelector('[data-demo-ui]').textContent);
    const select = root.querySelector('[data-demo-select]'), form = root.querySelector('[data-demo-form]');
    const drafts = new Map();
    courses.forEach(c => { const o = document.createElement('option'); o.value = c.id; o.textContent = c.name; select.append(o); });
    const requested = new URLSearchParams(location.search).get('journal');
    if (courses.some(c => c.id === requested)) select.value = requested;
    const render = () => {
      const c = courses.find(c => c.id === select.value) || courses[0];
      root.querySelector('[data-demo-title]').textContent = c.title;
      root.querySelector('[data-demo-lesson]').textContent = c.lesson;
      root.querySelector('[data-demo-page]').textContent = c.page;
      form.replaceChildren();
      c.questions.forEach((question, i) => {
        const label = document.createElement('label'), input = document.createElement('textarea');
        input.id = select.id + '-answer-' + i; label.htmlFor = input.id; label.textContent = question;
        input.maxLength = 12000; input.rows = 3; input.placeholder = ui.placeholder;
        input.value = drafts.get(c.id)?.[i] || '';
        input.addEventListener('input', () => { const values = drafts.get(c.id) || []; values[i] = input.value; drafts.set(c.id, values); });
        form.append(label,input);
      });
    };
    form.addEventListener('submit',e=>e.preventDefault());
    select.addEventListener('change',render);
    render();
  };
  document.querySelectorAll('[data-kana-free-hub]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-kana-free-hub]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kana-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.mobile-menu[open], .kana-journal-menu[open], .kana-header-search[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
  const closeMenu = event.target.closest('[data-kana-menu-close]');
  if (closeMenu) { const menu = closeMenu.closest('details'); menu.open = false; menu.querySelector('summary').focus(); }
  if (event.target.closest('.mobile-menu a')) setTimeout(() => { if (!event.defaultPrevented) document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open')); }, 0);
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const menu = document.querySelector('.kana-journal-menu[open], .mobile-menu[open], .kana-header-search[open]');
  if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
});
document.addEventListener('focusin', event => {
  document.querySelectorAll('.kana-journal-menu[open], .kana-header-search[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
const markCurrentNavigation = () => {
  document.querySelectorAll('.site-header nav a[href]').forEach(link => {
    const target = new URL(link.href, location.href);
    if (target.origin === location.origin && target.pathname === location.pathname && target.search === location.search) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
  });
};
const setupJournalMenus = () => {
  document.querySelectorAll('.kana-journal-menu, .mobile-menu, .kana-header-search').forEach(menu => {
    if (menu.dataset.ready) return;
    menu.dataset.ready = 'true';
    const summary = menu.querySelector('summary');
    const update = () => summary.setAttribute('aria-expanded', String(menu.open));
    menu.addEventListener('toggle', () => {
      update();
      if (menu.open && menu.classList.contains('kana-header-search')) {
        document.querySelectorAll('.mobile-menu[open], .kana-journal-menu[open], .kana-guide-disclosure[open]').forEach(other => { other.open = false; });
        menu.querySelector('input[type="search"]').focus({ preventScroll: true });
      }
    });
    if (menu.classList.contains('kana-journal-menu')) {
      let closeTimer;
      let openedByHover = false;
      const clearClose = () => clearTimeout(closeTimer);
      menu.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        clearClose();
        if (!menu.open) { openedByHover = true; menu.open = true; }
        document.querySelectorAll('.kana-header-search[open], .kana-guide-disclosure[open]').forEach(searchMenu => { searchMenu.open = false; });
      });
      menu.addEventListener('pointerleave', () => {
        clearClose();
        closeTimer = setTimeout(() => {
          if (!menu.querySelector('.kana-journal-links').contains(document.activeElement)) { menu.open = false; openedByHover = false; }
        }, 220);
      });
      menu.addEventListener('focusin', clearClose);
      summary.addEventListener('click', event => {
        if (openedByHover && menu.open) { event.preventDefault(); openedByHover = false; }
      });
    }
    update();
  });
};
setupJournalMenus();
document.addEventListener('shopify:section:load', setupJournalMenus);
markCurrentNavigation();
document.addEventListener('shopify:section:load', markCurrentNavigation);

const setupGuideMenus = () => {
  document.querySelectorAll('.kana-guide-menu').forEach(wrapper => {
    if (wrapper.dataset.ready) return;
    wrapper.dataset.ready = 'true';
    const details = wrapper.querySelector('details');
    const summary = details.querySelector('summary');
    const title = wrapper.querySelector('.kana-guide-title');
    let timer;
    const sync = () => summary.setAttribute('aria-expanded', String(details.open));
    const close = () => { clearTimeout(timer); details.open = false; sync(); };
    const open = () => {
      clearTimeout(timer);
      document.querySelectorAll('.kana-guide-disclosure[open], .kana-journal-menu[open], .kana-header-search[open]').forEach(other => { if (other !== details) other.open = false; });
      details.open = true; sync();
    };
    details.addEventListener('toggle', sync);
    wrapper.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse' && wrapper.closest('.desktop-nav') && matchMedia('(hover: hover) and (pointer: fine)').matches) open();
    });
    wrapper.addEventListener('pointerleave', () => {
      clearTimeout(timer);
      if (wrapper.closest('.desktop-nav')) timer = setTimeout(() => {
        if (!wrapper.contains(document.activeElement)) close();
      }, 220);
    });
    wrapper.addEventListener('focusin', () => clearTimeout(timer));
    wrapper.addEventListener('focusout', event => { if (event.relatedTarget && !wrapper.contains(event.relatedTarget)) close(); });
    wrapper.addEventListener('keydown', event => {
      if (event.key === 'Escape' && details.open) { event.preventDefault(); event.stopPropagation(); close(); summary.focus(); }
      if (event.key === 'ArrowDown' && (event.target === title || event.target === summary)) {
        event.preventDefault(); open(); details.querySelector('a').focus();
      }
    });
    document.addEventListener('click', event => { if (!wrapper.contains(event.target)) close(); });
    sync();
  });
};
setupGuideMenus();
document.addEventListener('shopify:section:load', setupGuideMenus);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kana-newsletter"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('[data-news-dialog]');
    const toast = root.querySelector('[data-news-toast]');
    const KEY = 'kana-newsletter-seen-v1';
    let shown = false, toastTimer;
    try { shown = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    const mark = () => { shown = true; try { sessionStorage.setItem(KEY, '1'); } catch (e) {} };
    const notify = message => {
      mark();
      if (dialog.open) dialog.close();
      clearTimeout(toastTimer);
      toast.querySelector('[data-news-toast-text]').textContent = message;
      toast.hidden = false;
      toastTimer = setTimeout(() => { toast.hidden = true; }, 8000);
    };
    const open = manual => {
      if (dialog.open || (!manual && (shown || root.dataset.subscribed === 'true' || document.querySelector('dialog[open], [role="alertdialog"]')))) return;
      mark(); dialog.showModal();
    };
    root.querySelectorAll('[data-news-open]').forEach(b => b.addEventListener('click', () => open(true)));
    root.querySelectorAll('[data-news-close]').forEach(b => b.addEventListener('click', () => dialog.close()));
    dialog.addEventListener('click', e => {
      if (e.target === dialog) {
        const r = dialog.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();
      }
    });
    root.querySelector('[data-news-preview-form]')?.addEventListener('submit', e => {
      e.preventDefault(); root.querySelector('[data-news-preview-status]').hidden = false;
    });
    const form = root.querySelector('#KanaNewsletter');
    if (form) {
      let busy = false, approvedEmail = null;
      form.addEventListener('submit', async e => {
        const field = form.querySelector('[name="contact[email]"]');
        const email = field.value.trim().toLowerCase();
        if (approvedEmail === email) { approvedEmail = null; return; }
        e.preventDefault();
        if (busy || !form.reportValidity()) return;
        busy = true;
        const button = form.querySelector('[type="submit"]');
        const label = button.textContent;
        button.disabled = true;
        button.textContent = root.dataset.checking;
        form.setAttribute('aria-busy', 'true');
        let subscribed = false;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 7000);
        try {
          const response = await fetch(root.dataset.statusUrl, {
            method: 'POST', credentials: 'same-origin', redirect: 'error',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ email }), signal: controller.signal
          });
          if (response.ok) subscribed = (await response.json()).subscribed === true;
        } catch (error) {} finally {
          clearTimeout(timeout);
          busy = false; button.disabled = false; button.textContent = label;
          form.removeAttribute('aria-busy');
        }
        if (field.value.trim().toLowerCase() !== email) return;
        if (subscribed) {
          notify(root.dataset.alreadySubscribed);
          return;
        }
        if (form.reportValidity()) {
          approvedEmail = email;
          form.requestSubmit(button);
        }
      });
    }
    const result = root.querySelector('[data-news-result]');
    if (result.dataset.success === 'true') notify(result.dataset.successMessage);
    else if (root.querySelector('[data-news-error]')) open(true);
  };
  document.querySelectorAll('[data-kana-newsletter]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-kana-newsletter]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kana-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  if (!event.target.matches('.product-info select[name="id"]')) return;
  const price = event.target.closest('.product-info').querySelector('.product-price');
  if (price) price.textContent = event.target.selectedOptions[0].dataset.price;
});

  } catch(e) { console.error(e); }
})();
})();
